import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesPipelinesView } from "src/components/views/erp/sales/crm/salesPipelines/SalesPipelinesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesPipeline")({
	staticData: { title: i18n.t("sales_pipelines"), legacyViewKey: "salesPipelinePhasesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesPipelinesView />;
}
